import TrendDown from '@clearkit/icons/glyphs/TrendDown';
import TrendUp from '@clearkit/icons/glyphs/TrendUp';
import { CKSkeleton } from 'clearkit';

const successColor = 'green-500';
const dangerColor = 'gray-500';

type MetricWithPastValueComparison = {
  className?: string;
  currentRangeValue: number;
  currentRangeLoading: boolean;
  loadingSkeletonWidth?: string;
  displayName: string;
  pastRangeLoading: boolean;
  pastRangeValue: number;
  suffix?: string;
};

function MetricWithPastValueComparison({
  className,
  currentRangeLoading,
  currentRangeValue,
  loadingSkeletonWidth = '12ch',
  displayName,
  pastRangeLoading,
  pastRangeValue,
  suffix,
}: MetricWithPastValueComparison) {
  /**
   * Fun with floating point math. Round up to 2 decimal places
   * only if necessary. Whole numbers will not show .00
   */
  const valueChange = Number(
    Number(currentRangeValue - pastRangeValue).toFixed(2),
  );
  const trendingUp = currentRangeValue > pastRangeValue;
  const isLoading = currentRangeLoading || pastRangeLoading;

  const trendIconSizes = {
    height: '14px',
    width: '14px',
  };

  return (
    <div className={className}>
      <div className="flex items-center mb-2 leading-none gap-1">
        <CKSkeleton
          className="h-5 w-[10ch]"
          isLoading={isLoading}
          label="loading"
        >
          <div className="mr-2 font-semibold" style={{ fontSize: '1.25rem' }}>
            {suffix
              ? currentRangeValue
              : currentRangeValue.toLocaleString('en-US')}
            {suffix}
          </div>
          <div
            className={`flex gap-1 text-sm font-semibold items-center text-${
              trendingUp ? successColor : dangerColor
            }`}
          >
            {trendingUp ? (
              <TrendUp {...trendIconSizes} />
            ) : (
              <TrendDown {...trendIconSizes} />
            )}
            {valueChange.toLocaleString('en-US')}
            {suffix}
          </div>
        </CKSkeleton>
      </div>
      <CKSkeleton
        className="h-3.5"
        isLoading={isLoading}
        label="loading"
        width={loadingSkeletonWidth}
      >
        <div className="text-sm leading-tight">{displayName}</div>
      </CKSkeleton>
    </div>
  );
}
export default MetricWithPastValueComparison;
